import React, { useEffect, useMemo, useState } from "react";
import { FileText, Download, Loader2 } from "lucide-react";
import api, { downloadPdf } from "../../lib/api";
import { PageTitle, Card, Badge, Loading, fmtDate } from "./ui";

export default function Minutes() {
  const [minutes, setMinutes] = useState(null);
  const [filter, setFilter] = useState("All");
  const [busy, setBusy] = useState(null);

  useEffect(() => {
    api.get("/portal/minutes").then((r) => setMinutes(r.data)).catch(() => setMinutes([]));
  }, []);

  const dl = async (m) => {
    setBusy(m.id);
    try {
      await downloadPdf(`/portal/minutes/${m.id}/pdf`, `minutes-${m.date?.slice(0, 10)}.pdf`);
    } finally {
      setBusy(null);
    }
  };

  const types = useMemo(() => (minutes ? ["All", ...new Set(minutes.map((m) => m.type))] : ["All"]), [minutes]);

  if (!minutes) return <Loading />;
  const shown = filter === "All" ? minutes : minutes.filter((m) => m.type === filter);

  return (
    <div data-testid="minutes-page">
      <PageTitle eyebrow="Records" title="Minutes Archive" sub="Searchable minutes of Lodge meetings, visible to members only." />

      <div className="mb-6 flex flex-wrap gap-2">
        {types.map((t) => (
          <button
            key={t}
            onClick={() => setFilter(t)}
            className={`rounded-full px-4 py-2 font-sans text-xs font-semibold uppercase tracking-widest transition ${
              filter === t ? "bg-gold text-sapphire-deep" : "border border-sapphire-deep/15 text-ink/65 hover:border-gold hover:text-gold-deep"
            }`}
          >
            {t}
          </button>
        ))}
      </div>

      <div className="grid gap-4">
        {shown.map((m) => (
          <Card key={m.id} className="flex items-center justify-between gap-4">
            <div className="flex items-start gap-4">
              <FileText size={28} className="mt-1 shrink-0 text-gold-deep" />
              <div>
                <div className="mb-2"><Badge>{m.type}</Badge></div>
                <h3 className="font-display text-xl font-semibold text-sapphire-deep">{m.title}</h3>
                <p className="mt-1 font-sans text-sm text-ink/55">{fmtDate(m.date)} · {m.pages} pages</p>
                <p className="mt-2 max-w-2xl font-sans text-sm text-ink/65">{m.summary}</p>
              </div>
            </div>
            <button
              onClick={() => dl(m)}
              disabled={busy === m.id}
              className="flex shrink-0 items-center gap-2 rounded-full border border-gold/40 px-4 py-2 font-sans text-xs font-semibold uppercase tracking-widest text-gold-deep transition hover:bg-gold hover:text-sapphire-deep disabled:opacity-50"
              data-testid={`minutes-pdf-${m.id}`}
            >
              {busy === m.id ? <Loader2 size={14} className="animate-spin" /> : <Download size={14} />} PDF
            </button>
          </Card>
        ))}
      </div>
    </div>
  );
}
